import React from 'react';
import { useTranslation } from 'react-i18next';

export const MONTH_TYPE = {
  MONTH3: 3,
  MONTH6: 6,
  MONTH12: 12,
};

type Props = {
  onClick: (month: number) => void;
};

type ReturnType = {
  month: number;
  setMonth: (month: number) => void;
  MonthComponent: JSX.Element;
};

export default function useMonth({ onClick }: Props): ReturnType {
  const { t } = useTranslation();
  const [month, setMonth] = React.useState(MONTH_TYPE.MONTH3); // or 6, 12
  return {
    month,
    setMonth,
    MonthComponent: (
      <div className="N_12_R text-brown-grey flex justify-end">
        <div
          className={'cursor-pointer ' + (month === MONTH_TYPE.MONTH3 ? 'N_12_M text-black' : '')}
          onClick={() => {
            setMonth(MONTH_TYPE.MONTH3);
            onClick && onClick(MONTH_TYPE.MONTH3);
          }}
        >
          {t('product/my/month3')}
        </div>
        <div className="w-5 flex justify-center items-center">
          <div className="oval-1"></div>
        </div>
        <div
          className={'cursor-pointer ' + (month === MONTH_TYPE.MONTH6 ? 'N_12_M text-black' : '')}
          onClick={() => {
            setMonth(MONTH_TYPE.MONTH6);
            onClick && onClick(MONTH_TYPE.MONTH6);
          }}
        >
          {t('product/my/month6')}
        </div>
        <div className="w-5 flex justify-center items-center">
          <div className="oval-1"></div>
        </div>
        <div
          className={'cursor-pointer ' + (month === MONTH_TYPE.MONTH12 ? 'N_12_M text-black' : '')}
          onClick={() => {
            setMonth(MONTH_TYPE.MONTH12);
            onClick && onClick(MONTH_TYPE.MONTH12);
          }}
        >
          {t('product/my/year1')}
        </div>
      </div>
    ),
  };
}
